<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAddEditContactTitle">{{ 'kanban.categoryQuickForm.createCategory' | translate }}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.categoryQuickForm.name' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'kanban.categoryQuickForm.namePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'kanban.categoryQuickForm.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.categoryQuickForm.description' | translate }}
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="description"
                [placeholder]="'kanban.categoryQuickForm.descriptionPlaceholder' | translate"
              />
            </div>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="close()">
          {{ 'kanban.categoryQuickForm.close' | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          {{ 'kanban.categoryQuickForm.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
